import { CSSObject } from '@emotion/react'

export const emotionDial: CSSObject = {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '50%',
  margin: '0 auto',
  boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.05)', // For anti-aliasing reasons. Somewhat helps with the color canvas jaggedness.
}

export const rotator: CSSObject = {
  position: 'absolute',
  top: 0,
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
}

export const colorCanvas: CSSObject = {
  borderRadius: '50%', // clip pixels outside the circle
}

export const outerShadow: CSSObject = {
  position: 'absolute',
  top: 0,
  borderRadius: '50%',
  width: '100%',
  height: '100%',
  boxShadow: 'inset 0px 0px 5px 0px rgba(0,0,0,0.75)',
}
